import { compressSelector } from "store/features/compress/selectors/compressSelector";
import { CompressionSettings, CompressState } from "store/features/compress/types";
import { useAppDispatch, useAppSelector } from "store/store";
import { useCheckExpiry } from "./useCheckExpiry";
import {
    imageCompressionSettingsSetMaxFileSize,
    imageCompressionSettingsSetQuality,
    imageCompressionSettingsSetType,
} from "store/features/compress/actions";
import { getImageExtension } from "client/utils/getImageExtension";
import { useRouter } from "next/router";
import { useEffect } from "react";

export const useEditSettings = () => {
    const { selectedImageId, images, tooltipBounceImageId } = useAppSelector(compressSelector, equalityFn);
    const shouldTooltipAnimate = selectedImageId === tooltipBounceImageId;
    const dispatch = useAppDispatch();
    const { pathname } = useRouter();
    const selectedImage = images.find((_i) => _i.id === selectedImageId) ?? null;
    useCheckExpiry(selectedImage);

    const handleQualityChange = (quality: number, imageId: string) =>
        dispatch(
            imageCompressionSettingsSetQuality({
                imageId,
                value: quality,
            }),
        );
    const handleMaxFileSizeChange = (size: number, imageId: string) =>
        dispatch(imageCompressionSettingsSetMaxFileSize({ imageId, value: size }));
    const handleTypeChange = (type: CompressionSettings["type"], imageId: string) =>
        dispatch(imageCompressionSettingsSetType({ imageId, type }));
    const isMaxFileSizeDisabled = selectedImage
        ? !(
              getImageExtension(selectedImage.file.file) === "jpg" ||
              getImageExtension(selectedImage.file.file) === "jpeg"
          )
        : false;

    useEffect(() => {
        if (isMaxFileSizeDisabled && selectedImageId) {
            handleTypeChange("quality", selectedImageId);
        }
    }, [selectedImageId]);
    return {
        images,
        selectedImage,
        shouldTooltipAnimate,
        handleQualityChange,
        handleMaxFileSizeChange,
        handleTypeChange,
        isMaxFileSizeDisabled,
    };
};

const equalityFn = (left: CompressState, right: CompressState) => {
    if (
        JSON.stringify(left.selectedImageId) !== JSON.stringify(right.selectedImageId) ||
        JSON.stringify(left.images) !== JSON.stringify(right.images) ||
        left.tooltipBounceImageId !== right.tooltipBounceImageId
    )
        return false;

    return true;
};
